import { defineComponent as _defineComponent } from 'vue'
import { PGCode } from "@/types";
import useCurrencyFormat from "@/use/useCurrencyFormat";
import { PropType, computed } from "vue";


const __default__ = {
  name: "BookHistoryTotalAmount",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  totalBookAmount: {
    type: Number,
    required: true,
  },
  pgCode: {
    type: String as PropType<PGCode>,
    required: true,
  },
  totalCancelAmount: {
    type: Number,
    default: 0,
  },
  paymentAnnotation: {
    type: String,
  },
  cancelAnnotation: {
    type: String,
  },
  isMonthlyBook: {
    type: Boolean,
    default: false,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const paymentMethod = computed(() => {
  switch (props.pgCode) {
    case PGCode.KCP:
      return "신용카드";
    case PGCode.KakaoPay:
      return "카카오페이";
    case PGCode.FREE:
      return undefined;
    default:
      return undefined;
  }
});

const __returned__ = { props, paymentMethod, get useCurrencyFormat() { return useCurrencyFormat } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})